export default __webpack_public_path__ + "static/media/app-bar-save.8d416e62.svg";